 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin","route-boxs~route-gift":"route-boxs~route-gift","route-boxs":"route-boxs","route-gift":"route-gift","route-gashapon":"route-gashapon","route-huay":"route-huay","route-roulet":"route-roulet","route-spin":"route-spin","route-cashback":"route-cashback","route-continue":"route-continue","route-history":"route-history","route-home~route-lion~route-worldcup~route-worldcup-ranking":"route-home~route-lion~route-worldcup~route-worldcup-ranking","route-home~route-lion":"route-home~route-lion","route-home":"route-home","route-lion":"route-lion","route-worldcup":"route-worldcup","route-worldcup-ranking":"route-worldcup-ranking","route-login":"route-login","route-partner":"route-partner","route-play":"route-play","route-play-game":"route-play-game","route-promotion":"route-promotion","route-register":"route-register","route-register-pass":"route-register-pass","route-rewards":"route-rewards"}[chunkId]||chunkId) + "." + {"about":"7dcb2c6e","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"9873e6bf","route-boxs~route-gift":"7f1f99dd","route-boxs":"64006aba","route-gift":"9e963f77","route-gashapon":"df81e7b7","route-huay":"22b23413","route-roulet":"ff5c35a7","route-spin":"742fc60d","route-cashback":"da35148c","route-continue":"d453842e","route-history":"2b120358","route-home~route-lion~route-worldcup~route-worldcup-ranking":"156a2990","route-home~route-lion":"52bbbc0f","route-home":"6937aa8e","route-lion":"27051234","route-worldcup":"75752c0c","route-worldcup-ranking":"08d668d7","route-login":"67325f3d","route-partner":"eb4483f5","route-play":"66e5ded2","route-play-game":"f5cc7409","route-promotion":"8359d87f","route-register":"c078d521","route-register-pass":"3e22e1ae","route-rewards":"ffe38114","chunk-2ddaf3c8":"df87a48d","chunk-cd91b56a":"27a4f7d7","chunk-6bbd0be9":"9b28637c","chunk-6a80a6c6":"7d80403d","chunk-342f204c":"c28309b6","chunk-c8798f5c":"7bbe28b6","chunk-64a2f13e":"d918ef80","chunk-328e2716":"bc0f7604","chunk-926c3e34":"98978341","chunk-01f4e56b":"d426b3de","chunk-6233dde0":"7a2e4abf","chunk-5983665e":"fe9942cc","chunk-f1d58b32":"dd78e3c6","chunk-3fd04af5":"d05843df"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":1,"route-boxs~route-gift":1,"route-boxs":1,"route-gift":1,"route-gashapon":1,"route-huay":1,"route-roulet":1,"route-spin":1,"route-cashback":1,"route-continue":1,"route-history":1,"route-home":1,"route-lion":1,"route-worldcup":1,"route-worldcup-ranking":1,"route-login":1,"route-partner":1,"route-register":1,"route-register-pass":1,"route-rewards":1,"chunk-2ddaf3c8":1,"chunk-cd91b56a":1,"chunk-328e2716":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin","route-boxs~route-gift":"route-boxs~route-gift","route-boxs":"route-boxs","route-gift":"route-gift","route-gashapon":"route-gashapon","route-huay":"route-huay","route-roulet":"route-roulet","route-spin":"route-spin","route-cashback":"route-cashback","route-continue":"route-continue","route-history":"route-history","route-home~route-lion~route-worldcup~route-worldcup-ranking":"route-home~route-lion~route-worldcup~route-worldcup-ranking","route-home~route-lion":"route-home~route-lion","route-home":"route-home","route-lion":"route-lion","route-worldcup":"route-worldcup","route-worldcup-ranking":"route-worldcup-ranking","route-login":"route-login","route-partner":"route-partner","route-play":"route-play","route-play-game":"route-play-game","route-promotion":"route-promotion","route-register":"route-register","route-register-pass":"route-register-pass","route-rewards":"route-rewards"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"fc7c866d","route-boxs~route-gift":"f1839825","route-boxs":"703ad50d","route-gift":"3b0b0b30","route-gashapon":"180e7202","route-huay":"18f28f8d","route-roulet":"3a688be5","route-spin":"b5f5abb0","route-cashback":"88c269ae","route-continue":"a6a64ac7","route-history":"fa702339","route-home~route-lion~route-worldcup~route-worldcup-ranking":"31d6cfe0","route-home~route-lion":"31d6cfe0","route-home":"e10cac72","route-lion":"7f526b00","route-worldcup":"b64a0f78","route-worldcup-ranking":"c56ce496","route-login":"cee57340","route-partner":"4a5af3fa","route-play":"31d6cfe0","route-play-game":"31d6cfe0","route-promotion":"31d6cfe0","route-register":"91e6d19e","route-register-pass":"8dc3403d","route-rewards":"d1df3d01","chunk-2ddaf3c8":"aa9905e8","chunk-cd91b56a":"fda796e2","chunk-6bbd0be9":"31d6cfe0","chunk-6a80a6c6":"31d6cfe0","chunk-342f204c":"31d6cfe0","chunk-c8798f5c":"31d6cfe0","chunk-64a2f13e":"31d6cfe0","chunk-328e2716":"cbb24430","chunk-926c3e34":"31d6cfe0","chunk-01f4e56b":"31d6cfe0","chunk-6233dde0":"31d6cfe0","chunk-5983665e":"31d6cfe0","chunk-f1d58b32":"31d6cfe0","chunk-3fd04af5":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
